module.exports = __webpack_public_path__ + "static/media/video3.ba17cb40.jpg";